import { VEHICLE_CATALOG_TABLE_CONFIG } from '@common/models/vehicle/constants';

export const vehicleTableConfigForOrdersNTrips = {
  ...VEHICLE_CATALOG_TABLE_CONFIG,
  adding: false,
  deleting: false,
  export: false,
  copying: false
};
